// EditK85Block.jsx
import React, { useState, useCallback, useEffect } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { saveEditData } from './actions';

const text = "Редагування статистичної звітності";

const EditK85Block = ({ show, data, close }) => {
    const [formData, setFormData] = useState({});
    const [loading, setLoading] = useState(false);

    // Инициализация формы данными
    useEffect(() => {
        if (show && data.row) {
            setFormData({ ...data.row });
        }
    }, [show, data]);

    const onHide = useCallback(() => {
        setFormData({});
        setLoading(false);
        close();
    }, [close]);

    const onOkSave = useCallback((result) => {
        setLoading(false);
        close(true);
    }, [close]);

    const handleInputChange = useCallback((field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));
    }, []);

    const handleSubmit = useCallback(async (e) => {
        e.preventDefault();
        
        const { _id, month } = data;
        const d = data.row;

        const result = { _id, month, report: {} };
        const { report } = result;

        // Находим измененные поля
        Object.keys(formData).forEach(k => {
            if (formData[k] !== d[k]) {
                report[k] = formData[k];
            }
        });

        if (Object.keys(report).length === 0) {
            alert(`Жодних змін не внесено.`);
            return onHide();
        }

        setLoading(true);
        saveEditData(result, onOkSave, (err) => {
            setLoading(false);
            alert(`Помилка при збереженні редагованих даних: ${err}`);
        });
    }, [data, formData, onOkSave, onHide]);

    if (!show || !data.parts) return null;

    const { number, parts, titles } = data;
    const { fields } = parts;

    return (
        <Modal show={show} onHide={onHide} size="lg" className="k85-modal">
            <Modal.Header closeButton>
                <Modal.Title>
                    {text}. ЗДО {number}. {parts.title}, {parts.subtitle}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <div className="mb-4">
                        {fields.map((field, index) => (
                            <Form.Group as={Row} key={field} className="mb-3">
                                <Form.Label column md={6}>
                                    {titles[index]}
                                </Form.Label>
                                <Col md={6}>
                                    <Form.Control
                                        type="number"
                                        value={formData[field] || ''}
                                        onChange={(e) => handleInputChange(field, e.target.value)}
                                        disabled={loading}
                                        step="any"
                                    />
                                </Col>
                            </Form.Group>
                        ))}
                    </div>
                    
                    <Row className="mt-4">
                        <Col md={2} />
                        <Col md={4}>
                            <Button 
                                type="submit" 
                                variant="primary"
                                disabled={loading}
                                className="w-100"
                            >
                                {loading ? 'Збереження...' : 'Зберегти'}
                            </Button>
                        </Col>
                        <Col md={4}>
                            <Button 
                                type="button" 
                                onClick={onHide} 
                                variant="outline-secondary"
                                disabled={loading}
                                className="w-100"
                            >
                                Закрити
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default EditK85Block;